var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M25.412 16.077c-1.185 3.283-4.63 9.502-6.634 11.864a3 3 0 0 1-4.782-.274c-2.822-4.224-4.677-7.416-6.169-10.87C5.303 10.95 8.945 4.46 14.551 3.21c.631-.14 1.27-.21 1.911-.21 4.288 0 8.127 3.117 9.223 7.371.497 1.93.406 3.823-.273 5.706zM22.78 11.12C22.02 8.17 19.358 6 16.462 6c-.416 0-.837.045-1.259.138-3.427.765-6.527 5.057-4.622 9.469 1.592 3.686 3.67 7.041 5.91 10.393 1.814-2.138 5.066-8.08 6.099-10.941.475-1.318.536-2.596.19-3.94zM16.5 15c-1.493 0-3.01-1.343-3.01-3s1.517-3 3.01-3c1.493 0 2.913 1.5 2.913 3s-1.42 3-2.913 3z"}));
}

Location.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Location;

Location.default = Location;
